import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginForm from "./pages/LoginForm";
import RegisterForm from "./pages/RegisterForm";
import Home from "./pages/Home";
import CompanySetup from "./components/company/CompanySetup";
import EmployeeSetup from "./components/employee/EmployeeSetup";
import EmployeeSetup2 from "./components/employee/EmployeeSetup2";
import BiometricAttd from "./components/attendance/BiometricAttd";
import EmployeeList from "./components/employee/EmployeeList";
import TimeSheetPage from "./components/attendance/TimeSheetPage";
import EmployeeSetupGrid from "./components/employee/EmployeeSetupGrid";
import PayroleSet from "./components/payroll/PayroleSet";
import Logout from "./pages/Logout";
import CompanyDetails from "./components/company/CompanyDetails";
import Validation from "./components/attendance/Validation";
import ProtectedRoute from "./components/common/ProtectedRoute";

import UploadTemplate from "./components/lettergeneration/UploadTemplate";
import GenerateLetter from "./components/lettergeneration/GenerateLetter";

import AdminAccountManagerRegister from "./pages/AdminAccountManagerRegister";
import EmployeeRegister from "./pages/EmployeeRegister";
import EmployeeDetails from "./components/employee/EmployeeDetails";
import CreateRole from "./pages/CreateRole";
import Home1 from "./pages/Home1";
import Payslip from "./components/payroll/Payslip";
import VPayslip from "./components/payroll/VPayslip";
import "./App.css";

function RegisterAndLogout() {
  localStorage.clear();
  return <RegisterForm />;
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LoginForm />} />
          <Route path="/home1" element={<Home1 />} />
          <Route path="/payslip" element={<Payslip />} />
          <Route path="/vpayslip" element={<VPayslip />} />


          <Route
            path="/createrole"
            element={
              <ProtectedRoute >
                <CreateRole />
              </ProtectedRoute>}/>
          <Route
            path="/adminregister"
            element={
              <ProtectedRoute restrict={true}>
                <AdminAccountManagerRegister />
              </ProtectedRoute>}/>
          <Route
            path="/employeeregister"
            element={
              <ProtectedRoute restrict={true}>
                <EmployeeRegister />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employeedetails"
            element={
              <ProtectedRoute>
                <EmployeeDetails />
              </ProtectedRoute>
            }
          />

          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<RegisterAndLogout />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute >
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companysetup"
            element={
              <ProtectedRoute restrict={true}>
                <CompanySetup />
              </ProtectedRoute>
            }
          />
          <Route path="/employeesetup" element={<EmployeeSetup />} />

          <Route
            path="/employeesetup2"
            element={
              <ProtectedRoute restrict={true}>
                <EmployeeSetup2 />
              </ProtectedRoute>
            }
          />

          <Route
            path="/employeelist"
            element={
              <ProtectedRoute restrict={true}>
                <EmployeeList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/EmployeeSetupGrid"
            element={
              <ProtectedRoute restrict={true}>
                <EmployeeSetupGrid />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Attendance"
            element={
              <ProtectedRoute restrict={true}>
                <TimeSheetPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroleset"
            element={
              <ProtectedRoute restrict={true}>
                <PayroleSet />
              </ProtectedRoute>
            }
          />
         
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/companydetails"
            element={
              <ProtectedRoute restrict={true}>
                <CompanyDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Validation"
            element={
              <ProtectedRoute restrict={true}>
                <Validation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/biometric"
            element={
              <ProtectedRoute restrict={true}>
                <BiometricAttd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/uploadtemplate"
            element={
              <ProtectedRoute restrict={true}>
                <UploadTemplate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/generateletter"
            element={
              <ProtectedRoute restrict={true}>
                <GenerateLetter />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
